import { Box } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useAppStore } from "../app/store";
import { AuthContext } from "../contexts";
import authService from "./auth.service";
import LoginView from "./login.view";
import _ from "lodash";

export default function AuthProvider({ children }) {
	const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

	const { user, setUser } = useAppStore();
	const [loaded, setLoaded] = useState(false);

	const auth = useMemo(() => createAuth(user), [user]);

	function createAuth(user) {
		const permissions = new Set(user?.permissions);

		return {
			can(permission) {
				return permissions?.has(permission);
			},
			canAny(perms) {
				return _.some(perms, p => permissions?.has(p));
			},
			canAll(perms) {
				return _.every(perms, p => permissions?.has(p));
			},
		};
	}

	const init = async () => {
		if (!user?.id) {
			let result = await authService.check();
			if (!result?.data?.data) {
				result = await authService.login('refresh');
			}
			const u = result?.data?.data;
			setUser(u);
		}
		setLoaded(true);
	};

	useEffect(() => {
		init();
	}, []);

	let result;
	if (!loaded) {
		result = <Box></Box>
	}
	else {
		if (user) {
			result = children;
		}
		else {
			result = <LoginView />
		}
	}

	return (
		<AuthContext.Provider value={auth}>
			<GoogleOAuthProvider clientId={clientId}>
				{result}
			</GoogleOAuthProvider>
		</AuthContext.Provider>
	);
}

export function useAuth() {
    return useContext(AuthContext);
}